import { ButtonForm, Validation } from "../../forms-template.service";

export interface SettingGrid {
minSearch?:number
        campoTabRif?: string;
        masterKey?: any;
        keyUnique?: any;
        wingap?:boolean;
        selectionMode?: 'single' | 'detail' | 'multiple' | 'none';
        remoteOperations?: boolean;
        api_rest?: boolean;
        searchType?: 'startsWith' | 'contains';
        hoverStateEnabled?: boolean;
        sortingMode?: string;
        rowAlternationEnabled?: boolean;
        repaintChangesOnly?: boolean;
        searchAndSelect?: boolean;
        searchAndSelectDataSource?: string;
        allowUpdating?: boolean;
        allowDeleting?: boolean;
        allowAdding?: boolean;
        columnAutoWidth?: boolean;
        width?: number;
        height?: number;
        mode?: string;
        showColBlank?: boolean;
        desButtonAdd?: string;
        outputData?: boolean;
        dataInput?: any,
        showFilterSearch?: boolean;
        bottoniSottoGriglia?: boolean;
        toolbarButtonsBottomLeft?:any;
        toolbarButtonsBottomRight?:any;
        toolbarButtonsTopRight?:any;
        isOdata?:boolean;
        showToolbarBottom?: boolean;
        rowDragging?: {
          allowReordering?: boolean,
          showDragIcons?: boolean
        };
        overrideDataSource?:any,
        concatDataField?:any,
        colonne?: {
          type?: string;
          dataField: string;
          width?: number;
          colWidth?: string | number;
          dataType: string;
          style?:string;
          caption?: string;
          colVisible?: boolean;
          colAlignment?:string
          hideOnEdit?: boolean,
          disableOnUpdate?: boolean;
          groupIndex?: number;
          showEditorAlways?: boolean;
          falseText?: string,
          trueText?: string,
          defaultValue?: any;
          class?: string;
          allowEditing?: boolean;
          lista?: any
          validation?: Validation[];
          colSpan?: any;
        }[];
        customNewRowBtn?:string;
        enabledCustomButton?: boolean;
        toolbarButtons?: ButtonForm[];
        toolbarButtonsBottom?: any;
        toolbarButtonsTop?: any;
}


// selezione gridSelect dinamiche, in modo da gestire un solo service per tutto il progetto
export const gridSimple : SettingGrid = {
    campoTabRif: '',
    masterKey: 'id',
    keyUnique: '',
    mode: 'cell',
    selectionMode: 'single',
    rowAlternationEnabled: true,
    remoteOperations: true,
    allowUpdating: false,
    allowDeleting: false,
    allowAdding: false,
    searchAndSelect: true, //Cerca Valore e seleziona
    searchType: 'contains',
    height: 500,
    width: 600,
    showColBlank: true,
    toolbarButtonsBottomLeft:null,
    toolbarButtonsBottomRight:[0],
    isOdata:true,
    overrideDataSource:null,
    concatDataField:null,
   

}
export const gridDetail : SettingGrid = {

    campoTabRif: '',
    masterKey: 'id',
    keyUnique: '',
    mode: 'cell',
    selectionMode: 'detail',
    rowAlternationEnabled: true,
    remoteOperations: true,
    allowUpdating: false,
    allowDeleting: false,
    allowAdding: false,
    searchAndSelect: true, //Cerca Valore e seleziona
    height: 500,
    width: 600,
    toolbarButtonsBottomLeft:null,
    toolbarButtonsBottomRight:[0],
    isOdata:true,
    overrideDataSource:null,
    concatDataField:null,
    toolbarButtonsTopRight:[],
    colonne: [
        // 
    ]

}

export const gridMultiple : SettingGrid = {
    campoTabRif: '',
    masterKey: 'id',
    keyUnique: '',
    mode: 'cell',
    selectionMode: 'multiple',
    rowAlternationEnabled: true,
    remoteOperations: true,
    allowUpdating: false,
    allowDeleting: false,
    allowAdding: false,
    searchAndSelect: true, //Cerca Valore e seleziona
    height: 500,
    width: 600,
    showToolbarBottom:true,
    toolbarButtonsBottomLeft:null,
    toolbarButtonsBottomRight:[22,23],
    isOdata:true,
    overrideDataSource:null,//serv sul per autorizzazione area, dove tengo una griglia nella form e devo già selezionare i dati delle modalità di smatimento.;
    concatDataField:null,//che serv sul per autorizzazione area, dove tengo una griglia nella form e devo già selezionare i dati delle modalità di smatimento.;
    colonne: [
        
        {
            dataField: 'descrizione',
            dataType: '',
            caption: 'Descrizione',
            colWidth: 530,
            allowEditing: true,
        }, 
    ]

}

export const gridMultipleCrm : SettingGrid = {
    campoTabRif: '',
    masterKey: 'id',
    keyUnique: '',
    mode: 'cell',
    selectionMode: 'multiple',
    rowAlternationEnabled: true,
    remoteOperations: true,
    allowUpdating: false,
    allowDeleting: false,
    allowAdding: false,
    searchAndSelect: true, //Cerca Valore e seleziona
    height: 500,
    width: 600,
    showToolbarBottom:true,
    toolbarButtonsBottomLeft:null,
    toolbarButtonsBottomRight:[22,23],
    isOdata:false,
    overrideDataSource:null,//serv sul per autorizzazione area, dove tengo una griglia nella form e devo già selezionare i dati delle modalità di smatimento.;
    concatDataField:null,//che serv sul per autorizzazione area, dove tengo una griglia nella form e devo già selezionare i dati delle modalità di smatimento.;
    colonne: [
        
        {
            dataField: 'descrizione',
            dataType: '',
            caption: 'Descrizione',
            colWidth: 530,
            allowEditing: true,
        }, 
    ]

}
export const gridEditable : SettingGrid = {
    campoTabRif: '',
    masterKey: 'id',
    keyUnique: '',
    mode: 'cell',
    selectionMode: 'single',
    rowAlternationEnabled: true,
    remoteOperations: true,
    allowUpdating: true,
    allowDeleting: true,
    allowAdding: true,
    searchAndSelect: true, //Cerca Valore e seleziona
    height: 500,
    width: 600,
    showColBlank: true,
    toolbarButtonsBottomLeft:null,
    toolbarButtonsBottomRight:[0],
    isOdata:true,
    colonne: [
        {
            dataField: 'descrizione',
            dataType: '',
            caption: 'Descrizione',
            allowEditing: true,
        },
    ]

}


// Funzione per creare configurazioni di griglia dinamiche
export function createGridConfig(data:any) : SettingGrid  {
    return data
}